const NavMain = (({ jQuery: $ }) => {
    class NavMain {
        constructor(node) {
            this.$node = $(node);
            this.$hero = $('.hero-frontpage');
            this.$searchTrigger = $('[data-js="search-trigger"]');
            this.$searchBar = $('[data-js="search-bar"]');
            this.$searchBarForm = $('#searchbox');
            this.activeClass = 'js-is-active';

            //state
            this.searchBarIsOpen = false;
        }

        initSearchBar() {
            this.$searchBar.hide();
            this.$searchBar.append(this.$searchBarForm);
        }

        toggleSearchBar() {
            this.$searchBar.slideToggle(250);
            this.$searchTrigger.toggleClass(this.activeClass);

            //toggle state
            this.searchBarIsOpen = !this.searchBarIsOpen;
            this.setScrollBinding();
        }

        onScroll() {
            //if the searchbar is open anytime scrolling happens, close it

            if (this.searchBarIsOpen) {
                this.toggleSearchBar();
            }
        }

        setScrollBinding() {
            $(window).one('scroll', this.onScroll.bind(this));
        }

        setEventBindings() {
            this.$searchTrigger.on('click', this.toggleSearchBar.bind(this));
            this.$searchBarForm.on('click', (e) => {
                e.stopPropagation();
            });
        }

        init() {
            this.initSearchBar();
            this.setEventBindings();
        }
    }

    return {
        init({ selector }) {
            return new NavMain(selector).init();
        },
    };
})(window);

export default Object.create(NavMain);
